class AdSortableLayerBehaviour {

    constructor($rootScope) {
        
        this.$rootScope = $rootScope;

        let _self = this;

        return {
            restrict: 'A',
            scope: {
                "entity": "=adSortableLayerBehaviour"
            },
            link: ($scope, $el, $attr) => {

                $el.sortable({
                    stop: ( event, ui ) => {

                        let behavioursOrder = [];
                        
                        $("li", $el).each( (ix, el) => {
                            let behaviourId = $(el).attr("data-behaviourid");
                            let behaviour = $scope.entity.behaviours[behaviourId];
                            if(!!behaviour) {
                                behavioursOrder.push(behaviour);
                            }
                        });

                        $scope.entity.behaviours.splice(0);
                        behavioursOrder.forEach(behaviour => {
                            $scope.entity.behaviours.push(behaviour);
                        });

                        $scope.$apply();
                    }
                });

            }
        };

    }


}

angular.module('cpm')
    .directive('adSortableLayerBehaviour', ['$rootScope', ($rootScope) => {
        'use strict';
        return new AdSortableLayerBehaviour($rootScope);
    }]);
